import { Component, Input, OnInit } from '@angular/core'
import { DailyLogService } from 'src/app/services/daily-log/daily-log.service'

@Component({
  selector: 'app-daily-log-memo-reaction',
  templateUrl: './daily-log-memo-reaction.component.html',
  styleUrls: ['./daily-log-memo-reaction.component.scss'],
})
export class DailyLogMemoReactionComponent implements OnInit {
  constructor(private dailyLogService: DailyLogService) {}

  @Input() limitTextLines = true
  @Input() memo: string | undefined
  @Input() profileImageUrl: string | undefined
  @Input() anonymousNumber: string | undefined
  @Input() commentCount = 0
  @Input() isPrivate = false
  @Input() isListView = false

  ngOnInit() {}

  onClickComment(): void {
    this.dailyLogService.onClickMemoComment()
  }
}
